import React from 'react';
import PropTypes from 'prop-types';
import GeneralComments from 'components/pure/scorecards/live-coaching/GeneralComments';
import CallRecordingLink from 'components/pure/scorecards/live-coaching/CallRecordingLink';
import LiveCoachingStore from 'stores/scorecards/LiveCoachingStore';
import connectToStores from 'alt-utils/lib/connectToStores';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import CoachingReviewStore from 'stores/coaching/CoachingReviewStore';
import LiveCoachingActions from 'actions/scorecards/LiveCoachingActions';
import {List} from 'immutable';
import Loading from 'components/pure/utils/Loading';

@connectToStores
export default class ExtraReview extends React.PureComponent {
  state = {loading: true};

  static propTypes = {
    newSession: PropTypes.bool,
    isEditing: PropTypes.bool,
    callId: PropTypes.string,
    reviewId: PropTypes.number,
  };

  static getStores() {
    return [LiveCoachingStore, CoachingReviewStore];
  }

  static getPropsFromStores({callId}) {
    const {generalComments, callRecordingLink, liveCoachingReviews} = LiveCoachingStore.getState();
    const review = liveCoachingReviews.get(callId);
    return {
      generalComments,
      callRecordingLink,
      review,
      reviewFileUpload: CoachingReviewStore.getState()
        .reviewFileUploads.get(review && review.id, List())
        .find(({fileuploadId}) => fileuploadId === callId),
    };
  }

  componentDidMount() {
    const {callId} = this.props;
    setTimeout(() => {
      this.setState({loading: true}, async () => {
        // fetch review data for this call, if we're given a reviewId favor that
        const [, review] = await LiveCoachingActions.retrieveForCall(callId);
        if (!review) return this.setState({loading: false});

        const {reviewFileUploads = List()} = await CoachingReviewActions.fetchReviewFeedback(
          review.id
        );
        const reviewFileUpload = reviewFileUploads.find(
          ({fileuploadId}) => fileuploadId === callId
        );

        // if reviewFileUpload is defined, then this session is already completed. Default store
        // to the existing values.
        if (reviewFileUpload) {
          LiveCoachingActions.setGeneralComments.defer(reviewFileUpload.comment);
          LiveCoachingActions.setCallRecordingLink.defer(reviewFileUpload.callRecordingLink);
        }

        this.setState({loading: false});
      });
    });
  }

  render() {
    const {isEditing, review, reviewFileUpload, generalComments, callRecordingLink, newSession} =
      this.props;
    if (this.state.loading) return <Loading />;

    // If this isn't a new session and theres no review that probably
    // means the user can see the call but not the review, hide
    // in this case
    if (!review && !newSession) return null;

    return (
      <div className="live-coaching-extra-review">
        <GeneralComments
          isEditing={isEditing}
          generalComments={generalComments}
          reviewFileUpload={reviewFileUpload}
          reviewId={review && review.id}
        />
        <CallRecordingLink isEditing={isEditing} callRecordingLink={callRecordingLink} />
      </div>
    );
  }
}
